import './button.less'
import m from 'mithril'
import {classes, Image} from '@codeurs/front'
import {Component, Icon} from '@codeurs/front'

export default class Button extends Component<{
	type?: string
	class?: string
	mod?: any
	[key: string]: any
}> {
	view() {
		const {type = 'a', class: className, mod, ...attrs} = this.attrs
		let arrow = false
		if (mod) arrow = mod.split(' ').includes('arrow')
		return m(`${type !== 'a' ? 'button' : 'a'}.button`,
			{
				...classes(className, {mod}),
				...attrs,
				type: type !== 'a' ? type : undefined
			},
			[this.children, arrow && m(Icon, {class: 'button-arrow', icon: 'arrow'})]
		)
	}
}

export class ButtonText extends Component {
	view() {
		return m('span.button-text', this.children)
	}
}

export class ButtonIcon extends Component<{
	icon: string
	class?: any
}> {
	view() {
		return m('span.button-icon', m(Icon, this.attrs))
	}
}
